import React, { useState } from 'react'
import Btn from '../../components/button';
import styled from 'styled-components'
import TecspotLogo2 from '../../tools/logo/tecspotLlllll.png'
import { Marginer } from '../marginer';
import theme from '../../themes';
import { scroller } from 'react-scroll';
import { ToggleButton } from '../navbarToggler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import * as FaIcons from 'react-icons/fa'
import * as AiIcons from 'react-icons/ai'

import {Link, NavLink} from 'react-router-dom'
import {SidebarData} from './sidebarData'
import './Css/Navbar.css'




const NavBar = styled.div`
background-color:${theme.primary};
align-items:center;
position:fixed;
padding:20px;
`;

// const NavbarContainer = styled.div`
// width:100%;
// height:65px;
// padding:1rem 1rem;
// display:flex;
// justify-content:space-between;

// `;

const LogoContainer = styled.div`
:hover{

}
`;

const NavBarLogoImage = styled.img`

`;

const Navba = styled.nav`
.nav-menu{
list-style-type:none;
position:fixed;
top:5;
margin-left:13px;
display:flex;
flex-direction:column;
transition:850ms;
left:-100%;




}
.active{
    left:0;
    transition:350ms;
}



`;

const Linkk = styled(Link)`

`

const List = styled.li`
    list-style:none;
    margin:10px;

    a{
        text-decoration:none;
      

        :hover{
            background-color:${theme.primary};
            color:${theme.white};
            padding:10px;
            border-radius:5px;
            transition:all 500ms ease-in-out;
        }
    }
`

const UnorderedList = styled.ul`

`;






// const AccessibilityContainer = styled.div`
// display:flex;
// justify-content:space-between;


// @media screen and (max-width:580px){
//     display:none;
// }
// `;

// // const LoginButton = styled(Btn)`
// // background-color:transparent;
// // color:${theme.primary};
// // border:1px solid ${theme.primary};

// // &:hover{
// // background-color:${theme.primary};
// // border:1px solid ${theme.primary};
// // color:${theme.white};
// // }

// // `;

// const BtnContainer = styled.div`
// border:1px solid red;
// border-radius:5px;
// `


// export function Navbar(props){

//     const [isToggled,setIsToggled] = useState(false);

//     const toggleNavbar = ()=>{
//         setIsToggled((prevState) => !prevState)
//     }

//     const scrollToWhyTecspot = () =>{
//         scroller.scrollTo("whytecspot", {smooth: true, duration:"500"})
//       }
//       const scrollToComments = ()=>{
//           scroller.scrollTo("comments",{smooth:true, duration:"500"})
//       }
//       const scrollToWhatWeDo = ()=>{
//         scroller.scrollTo("whatwedo",{smooth:true, duration:"500"})
//     }

// return  <NavbarContainer>
// <LogoContainer>
//     <NavBarLogoImage src={TecspotLogo2}/>
// </LogoContainer>
// <AccessibilityContainer>
//     <Btn small>Home</Btn>
//     <Marginer direction="horizontal" margin="1rem"  />
//     <Btn onClick={scrollToWhatWeDo} small>Our Services</Btn>
//     <Marginer direction="horizontal" margin="1rem"  />
//     <Btn onClick={scrollToWhyTecspot} small>Why Tecspot</Btn>
//     <Marginer direction="horizontal" margin="1rem"  />

//     <Btn onClick={scrollToComments} small>Comments</Btn>



// // </AccessibilityContainer>
// // <ToggleButton>
// //     <a href=""><FontAwesomeIcon onClick={toggleNavbar} className="fa-2x" icon={faBars}>dddddzzzzzzzzdddddd</FontAwesomeIcon></a>
// // </ToggleButton>
// // </NavbarContainer>
// }


export function Navbar(){

    
    const [sidebar, setSidebar] = useState(false);

    const showSidebar = () => setSidebar(!sidebar);
    return(
        <>
        <div className="navbar homepage">
        <LogoContainer>
                <a href="https://tecspot-4730d.web.app"> <NavBarLogoImage src={TecspotLogo2}/></a>
      </LogoContainer>
      <nav className={sidebar ? 'nav-menu active':'nav-menu'}>
          <ul className='nav-menu-items' >
        
          
              {SidebarData.map((item, index)=> {
                  return(
                      <li key={index} className={item.cName} onClick={showSidebar}>
                      
                          <NavLink to={item.path} activeStyle={{borderBottom:"1px solid #ffffff"}} >
                              <span>{item.title}</span>
                          </NavLink>
                      </li>
                  )
              })}
          </ul>
      </nav>
    
        </div>  
        <Link to="#" className="menu-bars">
                <FaIcons.FaBars className="fa-2x ic"  onClick={showSidebar}/>
            </Link>



      </>
    )
}